import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './styles/globals.css';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProjectsPage from './pages/ProjectsPage';
import BlogsPage from './pages/BlogsPage';
import DiaryPage from './pages/DiaryPage';
import SocialsPage from './pages/SocialsPage';

const App = () => {
  const [theme, setTheme] = useState('dark');
  const nextTheme = theme === 'dark' ? 'light' : 'dark';
  
  const handleToggleTheme = () => {
    setTheme((current) => (current === 'dark' ? 'light' : 'dark'));
  };

  return (
    <Router>
      <div className={`app-shell ${theme === 'dark' ? 'theme-dark' : 'theme-light'}`}>
        <button
          type="button"
          className="theme-toggle-btn"
          onClick={handleToggleTheme}
          aria-pressed={theme === 'dark'}
          aria-label={`Switch to ${nextTheme} mode`}
          tabIndex={0}
        >
          {theme === 'dark' ? '☼' : '☽'}
        </button>

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/diary" element={<DiaryPage />} />
          <Route path="/socials" element={<SocialsPage />} />
        </Routes>

      </div>
    </Router>
  );
};

export default App;
